import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import RadioButtonText from "../../common/RadioButtonText";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import * as domainConstants from "../../../constants/DomainConstants";

const PlannenForm = (props) => {
	const PLANNEN_TOOLTIP = "Het toevoegen van architecturale plannen kan jouw dossier versterken.";
	const {
		beoordelingscriteria,
		disabled,
		errors,
		onChange,
		documenten,
		onDropFiles,
		onDeleteFile,
		color,
		fileTypes,
		fileSessionStarted,
		voorbeeldInplantingsplanURL,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	function getFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			return documenten.find(x => x.name === component).files;
		} else return [];
	}
	function hasFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			const files = documenten.find(x => x.name === component).files;
			if (files) {
				return files.length > 0 ? true : false;
			}
		}
		return false;
	}

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}


	return (
		<Fieldset title="Relevante documenten" tooltip={PLANNEN_TOOLTIP} tooltipWindowWidth={20} tooltipWindowAlignRight={false}>
			<RadioButtonText
				label="Zijn er architecturale plannen, bouwplannen, tekeningen of schetsen van het sportinfrastructuurproject beschikbaar?"
				name="plannenBeschikbaar"
				value={beoordelingscriteria.plannenBeschikbaar || hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
				onChange={onChange}
				size={12}
				disabled={disabled}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
				items={jaNee}
				horizontal
				validationMessage={errors ? errors.plannenBeschikbaar : ''}
				validationMessageType={validationMessageType}
			/>
			{beoordelingscriteria.plannenBeschikbaar == true || beoordelingscriteria.plannenBeschikbaar === "true" || hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen) ?
				<DownloadUploadFiles
					dossierId={beoordelingscriteria.dossierId}
					title="Plannen"
					center
					optional
					disabled={disabled}
					color={color}
					tab={domainConstants.DocumentTab.Criteria}
					component={domainConstants.ComponentName.ArchitectPlannen}
					onDelete={mapDeleteFile(domainConstants.ComponentName.ArchitectPlannen)}
					onDrop={mapDropFiles(domainConstants.ComponentName.ArchitectPlannen)}
					files={getFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
					fileTypes={fileTypes.ArchitectPlannen}
					fileSessionStarted={fileSessionStarted} />
				: ""}

			<FieldsetSubHeader linkText={"Voorbeeld inplantingsplannen"} linkUrl={voorbeeldInplantingsplanURL}>Geef een inplantingsplan van vóór en na de werken.</FieldsetSubHeader>
			<DownloadUploadFiles
				dossierId={beoordelingscriteria.dossierId}
				title="Inplantingsplan vóór de werken"
				size={6}
				disabled={disabled}
				color={color}
				tab={domainConstants.DocumentTab.Criteria}
				component={domainConstants.ComponentName.InplantingsplanVoorDeWerken}
				onDelete={mapDeleteFile(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
				onDrop={mapDropFiles(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
				files={getFilesForDossierComponent(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
				fileSessionStarted={fileSessionStarted}
				validationMessage={errors ? errors.ulInplantingsplanVoorDeWerken : ''}
				validationMessageType={validationMessageType}
			/>

			<DownloadUploadFiles
				dossierId={beoordelingscriteria.dossierId}
				title="Inplantingsplan na de werken"
				size={6}
				disabled={disabled}
				color={color}
				tab={domainConstants.DocumentTab.Criteria}
				component={domainConstants.ComponentName.InplantingsplanNaDeWerken}
				onDelete={mapDeleteFile(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
				onDrop={mapDropFiles(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
				files={getFilesForDossierComponent(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
				fileSessionStarted={fileSessionStarted}
				validationMessage={errors ? errors.ulInplantingsplanNaDeWerken : ''}
				validationMessageType={validationMessageType} />
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
PlannenForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	fileTypes: PropTypes.object.isRequired,
	fileSessionStarted: PropTypes.bool,
	voorbeeldInplantingsplanURL: PropTypes.string,
	validationMessageType: PropTypes.string
};

export default PlannenForm;
